// tslint:disable:max-line-length

import React from 'react';

export const ChartGaugeOutline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,4.5c-4.4,0-8,3.6-8,8h3.2c0-2.7,2.1-4.8,4.8-4.8c1.3,0,2.5,0.5,3.4,1.4l2.3-2.3C12.2,5.4,10.2,4.5,8,4.5z" />
      <path d="M13.6,8.3c0.7,1,1.1,2.1,1.3,3.2h-1.2c-0.1-0.8-0.5-1.6-1-2.3L13.6,8.3 M13.7,6.8l-2.3,2.3c0.9,0.9,1.4,2.1,1.4,3.4H16 C16,10.3,15.1,8.3,13.7,6.8L13.7,6.8z" />
    </svg>
  );
};
